import { Attrs, MinzeElement } from 'minze'
import { Font } from '../../../constants'

export class LvcError extends MinzeElement {
  attrs: Attrs = [['error', false]]

  static observedAttributes = ['error']

  onAttributeChange(
    name?: string,
    oldValue?: string | null,
    newValue?: string | null
  ): Promise<void> | void {
    if (name === 'error') {
      this.error = newValue
    }
  }

  html = () => {
    const showError = typeof this.error === 'string' && this.error.length > 0

    if (!this.error) {
      return ``
    }

    if (!showError && this.error) {
      return `
        <lvc-box>
          <div class="error-label">
            <lvc-warning-icon>
            </lvc-warning-icon>
          </div>
        </lvc-box>
      `
    }

    return `
      <lvc-box>
        <div class="error-label">
          <lvc-warning-icon>
          </lvc-warning-icon>
          <span>${this.error}</span>
        </div>
      </lvc-box>
    `
  }
  css = () => {
    return `
    :host {
      width: 100%;
      position: relative;
      box-sizing: border-box;
      font-family: ${Font.family};
    }
    .error {
      background: #FFEBD7;
      border-bottom: 3px solid #FF4600;
    }
    .error-label {
      display: flex;
      margin-top: 4px;
      min-height: 24px;
      color: #FF0000;
      font-size: 12px;
      font-weight: ${Font.weight.bold};
      line-height: 24px;
    }

    .error-label span {
      display: inline-block;
      vertical-align: top;
    }

    .error-label lvc-warning-icon {
      display: inline-block;
      margin-right: 8px;
      width: 24px;
      height: 24px;
      vertical-align: top;
    }

  `
  }
}
